import { combineReducers } from 'redux';
import requirementsReducer from './requirements';
import formReducer from './form';
import dirty from './dirty';
import sitesReducer from './sites';
import contactsReducer from './contacts';
import zoneTemplates from './zoneTemplates';

export default combineReducers({
  requirements: requirementsReducer,
  form: formReducer,
  sites: sitesReducer,
  contacts: contactsReducer,
  dirty,
  zoneTemplates,
});

export const isFetching = state => {
  return state.requirements.isFetching || state.form.isFetching;
};



// WEBPACK FOOTER //
// ./src/modules/saas/aast/case-study/reducers/index.js